import DCILogo from "../../images/DCI.png";

// TODO: Get from Craft

const useData = () => ({
  logo: {
    url: DCILogo,
    width: 145,
    height: 49,
  },
  companyName: "Digital Control, Inc",
  contact: `
    19625 62nd Ave S Suite B103 Kent, WA 98032 U.S.
    dci@digital-control.com | digital - control.com
    1.800.288.3610 | 1.425.251.0559
    `,
});

export default useData;
